export const OfferTypes = [
  {
    value: "perk",
    label: "Broadcast a perk offer (time limited)",
  },
  {
    value: "tokenPay",
    label: "Broadcast a TokenPay offer (non limited)",
  },
];
export const tabs = ["Offer type", "Content", "Scheduling"];



// WEBPACK FOOTER //
// ./src/screens/Perks/constants/selections.js